import { type PropsWithChildren } from 'react';

import { WatchlistProviderWrapper } from '@/providers/WatchlistProviderWrapper';
import { PagePropsProvider } from '@/providers/PagePropsProvider';
import { ListingPageComponentRefsProvider } from '@/providers/ListingPageComponentRefsProvider';
import { ExposePageMountEffects } from '@/providers/ExposePageMountEffects';
import { ExposeModalProvider } from '@/providers/ExposeModalProvider';
import { type PropertyExposePageProps } from '@/pages/[marketCountryCode]/[locale]/exposes/[listingId]';
import { ExposeTrackingProvider } from '@/components/property-expose/ExposeTrackingProvider/ExposeTrackingProvider';

export const ListingPageProviders = ({ children, ...pageProps }: PropsWithChildren<PropertyExposePageProps>) => (
  <ListingPageComponentRefsProvider>
    <PagePropsProvider<PropertyExposePageProps> {...pageProps}>
      <ExposeTrackingProvider>
        <WatchlistProviderWrapper
          tracking={{
            snowplowApplicationId: 'new-search',
            ...pageProps.pageTrackingTypes,
          }}
        >
          <ExposePageMountEffects />
          <ExposeModalProvider>{children}</ExposeModalProvider>
        </WatchlistProviderWrapper>
      </ExposeTrackingProvider>
    </PagePropsProvider>
  </ListingPageComponentRefsProvider>
);
